import { createContext, useContext, useState, useEffect } from 'react';
import { authAPI } from '../api';

const AuthCtx = createContext(null);

// API response'larını tek bir tutarlı formata normalize eder
function normalizeUser(data) {
  if (!data) return null;
  // /api/me → { id, ad, ... }
  // /api/login → { user_id, ad, ... }
  const id = data.id ?? data.user_id ?? null;
  const ad = data.ad ?? null;
  const soyad = data.soyad ?? null;
  const role = data.role ?? null;

  // Zorunlu alanlar eksikse null döndür
  if (!id || !role) return null;

  return {
    id,
    ad: ad ?? '',
    soyad: soyad ?? '',
    email: data.email ?? '',
    role,
    merkez_id: data.merkez_id ?? null,
    bolge: data.bolge ?? null,
  };
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');

    if (new URLSearchParams(window.location.search).get('reset') === '1') {
      localStorage.clear();
      setUser(null);
      setLoading(false);
      return;
    }

    if (token) {
      authAPI.me()
        .then(r => {
          const normalized = normalizeUser(r.data);
          if (normalized) {
            setUser(normalized);
            localStorage.setItem('userMeta', JSON.stringify(normalized));
          } else {
            // Geçersiz/eksik kullanıcı verisi — oturumu temizle
            console.warn('Kullanıcı verisi eksik, oturum temizleniyor:', r.data);
            localStorage.clear();
            setUser(null);
          }
        })
        .catch(() => {
          localStorage.clear();
          setUser(null);
        })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }

    const handleStorage = (e) => {
      if (e.key === 'token') {
        if (!e.newValue) {
          setUser(null);
        } else if (e.newValue !== e.oldValue) {
          window.location.reload();
        }
      }
    };
    window.addEventListener('storage', handleStorage);
    return () => window.removeEventListener('storage', handleStorage);
  }, []);

  const login = async (email, password) => {
    const r = await authAPI.login(email, password);
    const normalized = normalizeUser(r.data);
    if (!normalized) throw new Error('Sunucudan geçersiz kullanıcı verisi döndü');
    localStorage.setItem('token', r.data.access_token);
    localStorage.setItem('userMeta', JSON.stringify(normalized));
    setUser(normalized);
    return normalized;
  };

  const logout = () => {
    localStorage.clear();
    setUser(null);
  };

  return (
    <AuthCtx.Provider value={{ user, login, logout, loading }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);